import { Card, CardBody, Tab, Tabs } from "@nextui-org/react";
import Tickets from "./Tickets";
import OnTicket from "./Ticket";
import { useState } from "react";
import NewTicket from "./NewTicket";
import { useSearchParams } from "react-router-dom";

const Ticket = ({ role }) => {
    const [searchParams] = useSearchParams();
    const TicketId = searchParams.get('ticket');
    const [onTicket, setOnTicket] = useState(TicketId ? { id: TicketId } : undefined)
    const [selected, setSelected] = useState("new");

    return (
        <>
            {!!onTicket ? <OnTicket status={selected} role={role} setOnTicket={setOnTicket} />
                : <Tabs
                    size="sm"
                    aria-label="Options"
                    selectedKey={selected}
                    onSelectionChange={setSelected}
                    className="border-b pb-3 w-full">
                    <Tab key="new" title='جدید'>
                        <Card className="!shadow-none rounded-none">
                            <CardBody>
                                <Tickets role={role} status='new' setOnTicket={setOnTicket} />
                            </CardBody>
                        </Card>
                    </Tab>
                    <Tab key="read" title='خوانده شده' >
                        <Card className="!shadow-none rounded-none">
                            <CardBody>
                                <Tickets role={role} status='read' setOnTicket={setOnTicket} />
                            </CardBody>
                        </Card>
                    </Tab>
                    <Tab key="answered" title='پاسخ داده شده' >
                        <Card className="!shadow-none rounded-none">
                            <CardBody>
                                <Tickets role={role} status='answered' setOnTicket={setOnTicket} />
                            </CardBody>
                        </Card>
                    </Tab>
                    {role == 'user' &&
                        <Tab key="newticket" title='ثبت تیکت جدید' >
                            <Card className="!shadow-none rounded-none">
                                <CardBody>
                                    <NewTicket />
                                </CardBody>
                            </Card>
                        </Tab>
                    }
                </Tabs>
            }
        </>
    );
};

export default Ticket;